import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton component for form/detail pages.
 */
export function LoadingSkeleton() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-8 w-2/5" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/5" />
      <Skeleton className="h-4 w-full" />
    </div>
  );
}

/**
 * Loading spinner component for inline loading states.
 */
export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="h-6 w-6 border-2 border-border border-t-primary rounded-full animate-spin" />
    </div>
  );
}
